import { MenuItem } from '@app/layouts/sidebar/menu.model';

export function filterMenuByPermissions(menu: MenuItem[], userPermissions: string[]): MenuItem[] {
  return menu
    .map(item => {
      const filteredSubItems = item.subItems
        ? filterMenuByPermissions(item.subItems, userPermissions)
        : undefined;

      const hasPermission =
        !item.permissions || item.permissions.some(p => userPermissions.includes(p));

      if (hasPermission || (filteredSubItems && filteredSubItems.length)) {
        return {
          ...item,
          ...(filteredSubItems ? { subItems: filteredSubItems } : {})
        } as MenuItem;
      }

      return null;
    })
    .filter((item): item is MenuItem => item !== null);
}
